import styled, { css } from 'styled-components';
import {
  ItemContainer,
  ItemCount,
  ItemDetails,
  ItemName,
} from 'src/components/MeasureSidebar/MeasureExtendedSidebar/styled';

export const Container = styled(ItemContainer)`
  ${({ theme }) => css`
    padding-top: ${theme.utils.pxToRem(8.2)}rem;
    padding-left: ${theme.utils.pxToRem(17.2)}rem;
    height: ${theme.utils.pxToRem(50)}rem;
  `}
`;

export const CountBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 16px;
  border-radius: 2px;
  ${({ theme }) => css`
    border: solid 1px ${theme.colors.viewer.sidebar.segmentCountBoxBorder};
    background-color: ${theme.colors.defaultActionBlue};
  `}
`;

export const Count = styled(ItemCount)`
  ${({ theme }) => css`
    padding-top: ${theme.utils.pxToRem(3)}rem;
  `}
`;

export const Details = styled(ItemDetails)`
  ${({ theme }) => css`
    color: ${theme.colors.viewer.sidebar.headerText};
    margin-left: ${theme.utils.pxToRem(12)}rem;
  `}
`;

export const Name = styled(ItemName)`
  ${({ theme }) => css`
    ${theme.mixins.font('medium', 12)}
  `}
`;

export const FeetInches = styled.div`
  ${({ theme }) => theme.mixins.font('book', 12)}
`;
